import { createSignal, Show } from "solid-js";
import { useAuth } from "../contexts/AuthContext";
import { useProfile } from "../contexts/ProfileContext";
import { getProfileConfig } from "../config/profiles";

export default function UserMenu() {
  const [isOpen, setIsOpen] = createSignal(false);
  const auth = useAuth();
  const { profile } = useProfile();

  const handleLogout = () => {
    setIsOpen(false);
    auth.logout();
  };

  const handleSwitchProfile = () => {
    setIsOpen(false);
    auth.logout();
  };

  const user = auth.user();
  if (!user) return null;

  const activeProfile = getProfileConfig(profile());

  return (
    <div class="relative">
      <button
        onClick={() => setIsOpen(!isOpen())}
        class="flex items-center space-x-2 text-white hover:text-blue-200 transition-colors"
      >
        <div class="w-8 h-8 bg-blue-700 rounded-full flex items-center justify-center text-sm font-medium">
          {user.name.charAt(0).toUpperCase()}
        </div>
        <span class="text-sm font-medium hidden sm:block">{user.name}</span>
        <svg
          class={`w-4 h-4 transition-transform ${isOpen() ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      <Show when={isOpen()}>
        <div class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">

          <div class="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
            <div class="font-medium">{user.name}</div>
            <div class="text-gray-500">{user.email}</div>
            <div class="text-xs text-blue-600 mt-1 capitalize">{user.role}</div>
          </div>

          <div class="px-4 py-3 text-sm text-gray-700 border-b border-gray-100 space-y-2">
            <div class="uppercase text-[11px] font-semibold text-gray-400 tracking-wide">
              Client Profile
            </div>
            <div
              class={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${activeProfile?.badgeClass ?? "bg-gray-200 text-gray-700"}`}
            >
              {activeProfile?.name ?? "Not selected"}
            </div>
            <button
              onClick={handleSwitchProfile}
              class="text-left w-full text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
              Switch client
            </button>
          </div>

          <button
            onClick={handleLogout}
            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <div class="flex items-center space-x-2">
              <svg
                class="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <span>Sign out</span>
            </div>
          </button>
        </div>
      </Show>

      <Show when={isOpen()}>
        <div class="fixed inset-0 z-40" onClick={() => setIsOpen(false)}></div>
      </Show>
    </div>
  );
}
